import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';
import { getPageTotalWritingTimeInSeconds, wordsCount } from '../../../Models';

export default class BombBadge extends WritingBadge {
  public readonly id = BadgeId.bomb;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    const pageWordsCount = wordsCount(stats.todaysPage);

    if (pageWordsCount < 300) {
      return false;
    }

    const writingDurationInMinutes = getPageTotalWritingTimeInSeconds(stats.todaysPage) / 60;
    const countOfWordsPerMinute = pageWordsCount / writingDurationInMinutes;

    return countOfWordsPerMinute > 60 && countOfWordsPerMinute < 100;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/bomb.ts